import { Pagination, PaginationLink } from '@aipb/gulliver/dynamic-gallery/model';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dg-record-pagination',
  templateUrl: './record-pagination.component.html',
  styleUrls: ['./record-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordPaginationComponent {
  @Input() pagination?: Pagination;

  @Output() pageChange: EventEmitter<PaginationLink> = new EventEmitter<PaginationLink>();
}
